var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnVisibilityPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 15 24.375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 0C12.0762 0 13.125 1.04883 13.125 2.34375C13.125 3.11016 12.757 3.79101 12.1875 4.21875V9.37515H12.2344C13.766 9.40093 15 10.6501 15 12.1876V15.0001H8.4375V19.6606C8.4375 20.9204 8.23477 22.172 7.83633 23.3671L7.5 24.375L7.16367 23.3671C6.76524 22.1718 6.5625 20.9203 6.5625 19.6606V15.0001H0V12.1876C0 10.6349 1.25976 9.37515 2.8125 9.37515V4.21875C2.24298 3.79101 1.875 3.11016 1.875 2.34375C1.875 1.04883 2.92383 0 4.21875 0H10.7812ZM10.7812 1.875H4.21874C3.95975 1.875 3.74999 2.08477 3.74999 2.34375C3.74999 2.49492 3.81913 2.62969 3.93866 2.71992L4.68749 3.28242V11.2501H2.81249C2.29451 11.2501 1.87499 11.6696 1.87499 12.1876V13.1251H13.125V12.1876C13.125 11.686 12.7301 11.2747 12.2332 11.2513L12.2039 11.2501L10.3125 11.2349V3.28248L11.0613 2.71998C11.1808 2.62975 11.25 2.49498 11.25 2.34381C11.25 2.08483 11.0402 1.875 10.7812 1.875Z",
    fill: "#009BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnVisibilityPinIcon);
export default __webpack_public_path__ + "static/media/ColumnVisibilityPinIcon.ea4c10cc0b1c513ca0b811effca21d37.svg";
export { ForwardRef as ReactComponent };